import React from 'react';
import { Section } from './Section';
import { Book, Radar, Shield, ScrollText, ClipboardList } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [{
  icon: Book,
  title: 'El Código de la Sombra (PDF eBook)',
  desc: 'El sistema completo de 5 capítulos para reprogramar tu presencia social.'
}, {
  icon: Radar,
  title: 'El Radar de Intenciones',
  desc: 'Un marco técnico para leer lo que la gente quiere de ti antes de que lo pidan.'
}, {
  icon: Shield,
  title: 'Protocolo de Escudo Cognitivo',
  desc: 'Técnicas verbales para neutralizar el gaslighting y las críticas pasivo-agresivas.'
}, {
  icon: ScrollText,
  title: 'Las 7 Leyes de la Psicología Oscura',
  desc: 'Cómo usar el silencio, la escasez y el espejo táctico para recuperar el respeto.'
}, {
  icon: ClipboardList,
  title: 'Hoja de Trabajo de Auditoría Social',
  desc: 'Para identificar exactamente quién está drenando tu poder actualmente.'
}];
export function WhatYouGet() {
  return <Section className="max-w-6xl" data-id="element-302">
      <div className="text-center mb-16" data-id="element-303">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-foreground" data-id="element-304">
          Lo que obtienes
        </h2>
        <div className="h-[1px] w-12 bg-blood mx-auto" data-id="element-305"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-306">
        {items.map((item, index) => {
        const Icon = item.icon;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`p-8 border border-border bg-dark relative group hover:border-blood/50 transition-colors duration-300 ${index === 0 ? 'md:col-span-2 lg:col-span-3 lg:w-2/3 lg:mx-auto' : ''}`} data-id="element-307">
              <div className="absolute top-0 left-0 w-full h-[2px] bg-blood scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" data-id="element-308"></div>

              <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-full bg-blood/10 text-blood" data-id="element-309">
                <Icon size={24} strokeWidth={1.5} data-id="element-310" />
              </div>

              <h3 className="text-xl font-bold mb-3 text-foreground font-serif" data-id="element-311">
                {item.title}
              </h3>
              <p className="text-foreground/70 font-sans font-light leading-relaxed" data-id="element-312">
                {item.desc}
              </p>
            </motion.div>;
      })}
      </div>
    </Section>;
}